import { clientFor, type PageQuery, type PageResult, type Status } from '@yc/api-client'

const api = clientFor('/wms/api')

export interface Customer {
  id: number
  tenant_id: number
  code: string
  name: string
  contact: string
  phone: string
  address: string
  status: Status
  created_at: string
  updated_at: string
}

export interface CustomerInput {
  code: string
  name: string
  contact: string
  phone: string
  address: string
  status: Status
}

export interface CustomerQuery extends PageQuery {
  keyword?: string
  status?: string
}

/** 与后端 services/wms/internal/customer 的字典保持一致，改一边必须改另一边 */
export const STATUS_LABELS: Record<Status, string> = { active: '启用', disabled: '停用' }

export const listCustomers = (q: CustomerQuery): Promise<PageResult<Customer>> =>
  api.get<PageResult<Customer>>('/customers', { ...q })

export const createCustomer = (input: CustomerInput): Promise<Customer> =>
  api.post<Customer>('/customers', input)

export const updateCustomer = (id: number, input: CustomerInput): Promise<Customer> =>
  api.put<Customer>(`/customers/${id}`, input)

export const deleteCustomer = (id: number): Promise<void> => api.del<void>(`/customers/${id}`)
